/** @format */

import { NUM_CONDENSER } from '../Constants/GRAPH_LIST';

export const modifyValue = function (Value, paramList) {
  const pages = paramList.find((item) => item.Param_Name === 'PAGES');
  const kpiCards = paramList.find((item) => item.Param_Name === 'KPI_LIST');
  const vectors = paramList.find((item) => item.Param_Name === 'VECTOR_LIST');
  const STATIC_CHARTS = paramList.find(
    (item) => item.Param_Name === 'STATIC_CHARTS'
  );

  const { charts, defaultVector, dropdownVector } =
    STATIC_CHARTS['Param_Value_Jsonb'];

  const staticVectors = dropdownVector.map((vector) => {
    vector.key = vector.columnname;
    if (vector.key === 'sales') {
      vector.denominator = NUM_CONDENSER;
    } else {
      vector.denominator = null;
    }

    return vector;
  });

  Value.params = paramList;
  Value.pages = pages ? pages['Param_Value_Jsonb'] : [];
  Value.kpi = kpiCards ? kpiCards['Param_Value_Jsonb'] : [];
  // global vectors
  Value.vectors = vectors['Param_Value_Jsonb'].map((vector) => {
    vector.key = vector.columnname;
    vector.display = true;
    // Initialize operation object if it doesn't exist
    if (!vector.operation) {
      vector.operation = {};
    } else if (vector?.operation?.denominator) {
      // Keep existing denominator
    } else {
      // Set denominator based on key
      vector.operation.denominator =
        vector.key === 'sales' ? NUM_CONDENSER : null;
    }
    delete vector.columnname;
    return vector;
  });

  Value.homepage.vectors = Value.vectors;
  Value.homepage.staticcharts['dropdownVectors'] = staticVectors;
  Value.homepage.staticcharts['defaultVector'] = defaultVector;

  charts.forEach((chart) => {
    Value.homepage.staticcharts[chart.id] = { ...chart, key: chart.id };
  });

  Value.datatree.table.columnCardVectors = Value.vectors;
  Value.drill_down.vector_togglers = Value.vectors.map((vector) => {
    vector.vector_id = vector.key;
    vector.modifiers = {};
    if (vector.key === 'sales') {
      vector.modifiers.divisor = NUM_CONDENSER;
    }
    vector.icon_id = 'CURRENCY';
    return vector;
  });

  return Value;
};
